import { types as t } from 'mobx-state-tree';

export const TestResult = t.model('TestResult', {
  correct: t.optional(t.number, 0),
  missed: t.optional(t.number, 0),
  score: t.optional(t.number, 0),
  total: t.optional(t.number, 0),
  wrong: t.optional(t.number, 0),
});
